import { render, staticRenderFns } from "./errorCodePage.vue?vue&type=template&id=5357e629&scoped=true&"
import script from "./errorCodePage.vue?vue&type=script&lang=js&"
export * from "./errorCodePage.vue?vue&type=script&lang=js&"
import style0 from "./errorCodePage.vue?vue&type=style&index=0&id=5357e629&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5357e629",
  null
  
)

export default component.exports